/**
 * ══════════════════════════════════════════════════════════════════════════
 * KLİP 5★ — TEK OTORİTE (saf: import yok, DOM yok, I/O yok)
 * ══════════════════════════════════════════════════════════════════════════
 *
 * ARIZA (ölçüldü, gerçek aritmetik):
 * **AYNI KLİP İKİ YÜZEYDE İKİ FARKLI YILDIZ GÖSTERİYORDU.**
 *
 *   MyClips akışı  → `EngagementRailV3` → `useClipEngagement` →
 *                    `onContentAggregate` → `aggNormalize` → `agg.avg`
 *                    = **HAM ortalama** (`sum / count`)
 *   Ana akış kartı → `ClipInFeed` → `clips/{id}.v3_ratingAvg`
 *                    ← `myclips_v3_rating_denorm.ts` → `deriveAgg(...).bayes`
 *                    = **BAYES** ((K·μ + sum) / (K + count))
 *
 * | klip              | MyClips akışı | ana akış |
 * |-------------------|---------------|----------|
 * | 10 oy, hepsi 5★   | 5.0★          | 3.6★     |
 * | 3 oy, hepsi 5★    | 5.0★          | 3.5★     |
 * | 500 oy, ort 4.8   | 4.8★          | 4.6★     |
 *
 * 5★ bu ürünün TEK kalite sinyalidir (`MYLASA_MAIN_LOOP_CANON.md`). Aynı
 * klibin iki sayısı olması o sinyali çürütür.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * 1. OTORİTE = BAYES (kanon kararı, seçim değil)
 * ══════════════════════════════════════════════════════════════════════════
 * `STAR_ECONOMY_V1_KARAR_KILITLEME.md` K1:
 *   *"Başlangıç Bayesyen μ=3.5'e demirli (UI'de sayı değil, 'yolculuk
 *   başladı')"*
 * Yani ham ortalama gösteren yüzey **sapmış olandır**. Sabitler
 * `functions/src/agg_derive.ts` ile BİREBİR aynıdır (aşağıdaki parite testi
 * ikisini karşılaştırır); burada YENİ bir formül tanımlanmıyor, sunucudaki
 * `bayesFrom` istemciye taşınıyor.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * 2. İKİ GİRDİ ŞEKLİ — AYNI SAYIYA ÇIKAR (yakınsamanın mekaniği)
 * ══════════════════════════════════════════════════════════════════════════
 * İki yüzey iki AYRI belgeden okuyor ve bu KALMALI (denorm alanı bir okuma
 * tasarrufudur, bkz. `myclips_v3_rating_denorm.ts`). Yakınsama, iki şeklin
 * cebirsel olarak **birbirine çevrilebilir** olmasından gelir:
 *
 *     bayes = (K·μ + sum) / (K + count)          ← `agg` {count,sum}'dan
 *     sum   = bayes·(K + count) − K·μ            ← denorm {count,bayes}'ten
 *
 * Bu yüzden ikisi de `klipYildizGorunumu`ya girer ve TEK bir sayı çıkar.
 * `sum` verilmişse o kazanır: `content/{id}.agg` ground-truth'tur, denorm
 * alanı tetikleyici gecikmesi kadar BAYAT olabilir.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * 3. DÜŞÜK GÜVEN EŞİĞİ — TÜRETİLDİ, SEÇİLMEDİ
 * ══════════════════════════════════════════════════════════════════════════
 * Bayes posteriorunda prior'ın ağırlığı `K / (K + n)`. Eşik olarak **n = K**
 * alındı, çünkü bu formüldeki TEK keyfi-olmayan noktadır: orada prior ile
 * veri **tam eşit** ağırlıktadır. Altında gösterilen sayı, klip hakkında
 * değil ağırlıklı olarak PRIOR hakkında bir şey söyler.
 *
 * Ölçülebilir hâli — n oyda gösterilebilecek en iyi/en kötü değer aralığı
 * (`4n / (K + n)`):
 *     n=3   → 3.54 .. 3.51   (aralık 0.12 ★ — hepsi 5★ olan klip "3.5")
 *     n=10  → 3.64 .. 3.27   (aralık 0.36 ★ — hepsi 5★ olan klip "3.6")
 *     n=100 → 4.25 .. 2.25   (aralık 2.00 ★ — sayı ilk kez ayırt edici)
 * Yani eşiğin altında "kusursuz klip" ile "berbat klip" AYNI sayıyı gösterir;
 * bu hem yanlıştır hem de kanon #11'in yasakladığı aşağılamadır (10 kişinin
 * 5★ verdiği klibe "3.6" yazmak).
 *
 * ⚖️ ELENEN İKİ ALTERNATİF (gerekçeleriyle):
 *  · **200** = `star_engine_shadow.ts GOLD_MIN_RATINGS`. Bu sayı tesadüf
 *    değil: kusursuz bir klibin Gold eşiği 4.5'e ULAŞABİLMESİ için gereken
 *    oy sayısı tam olarak 200'dür ((350+5n)/(100+n) ≥ 4.5 ⟺ n ≥ 200). Ama o
 *    soru "ölçeğin TEPESİNE ne zaman ulaşılır", bizim sorumuz "sayı ne zaman
 *    bir şey söyler". 200 seçilseydi sayı, tam Gold'un mümkün olduğu anda
 *    belirirdi → görünür bir "yolculuk" hiç olmazdı.
 *  · **10** = `star_engine_shadow.ts PROFILE_STAR_MIN_SAMPLE`. O sabit ≥3
 *    içerik üzerinden toplanan KULLANICI yıldızını yönetir (farklı kestirici,
 *    farklı varyans). Klip başına 10 oyda prior hâlâ %91 ağırlıktadır —
 *    yani düzeltmeye çalıştığımız kusur aynen kalırdı.
 *
 * 🔒 Eşik `PRIOR_STRENGTH`ten TÜRETİLİR (sabit sayı yazılmadı): prior gücü
 * ileride değişirse eşik kendiliğinden onunla gider, ayrışamaz.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * 4. EŞİK ALTI DİL — MEVCUT ÜRÜN DİLİ (yeni dil UYDURULMADI)
 * ══════════════════════════════════════════════════════════════════════════
 * Üç dize de bugün kod tabanında VAR ve owner-görünürdür:
 *   · `"✨ Star yolculuğu"`   — `ProfileHeaderMobile.tsx` journey chip'i
 *   · `"Star yolculuğu başladı"` — aynı chip'in `aria-label`'ı
 *   · `"—"`                   — `EngagementRailV3` sayacının bugünkü boş hâli
 * Geniş yüzeyler `metin`i, dar yüzeyler (rail, sayaç kutusu) `kisaMetin`i
 * basar; ikisi de AYNI karardan doğar.
 *
 * ⚠️ "HİÇ OY YOK" (`yok`) ile "OY VAR AMA AZ" (`yolculuk`) AYRI tutuldu.
 * Birleştirmek, platformdaki HER klibe bir yolculuk çipi takardı — oysa
 * puanlanmamış klip hakkında söylenecek bir şey yoktur ve bugünkü boş
 * görünümü korumak davranış deltasını sıfırda tutar.
 * ══════════════════════════════════════════════════════════════════════════
 */

/** Bayes prior ortalaması (μ). `functions/src/agg_derive.ts` ile BİREBİR. */
export const PRIOR_MEAN = 3.5;
/** Bayes prior gücü (K). `functions/src/agg_derive.ts` ile BİREBİR. */
export const PRIOR_STRENGTH = 100;

/**
 * Sayı gösterilebilmesi için gereken en az oy sayısı.
 * TÜRETİLMİŞTİR: prior ile verinin eşit ağırlıkta olduğu nokta (n = K).
 */
export const GUVEN_ESIGI = PRIOR_STRENGTH;

/** Yıldızın üst sınırı — şişmiş `sum` "7.4 ★" göstermesin (aggTuret başlığı). */
export const YILDIZ_TAVANI = 5;

/** Eşik altı geniş metin — `ProfileHeaderMobile.tsx` chip'iyle BİREBİR. */
export const YOLCULUK_METNI = "✨ Star yolculuğu";
/** Eşik altı `aria-label` — `ProfileHeaderMobile.tsx` ile BİREBİR. */
export const YOLCULUK_ARIA = "Star yolculuğu başladı";
/** Dar yüzey boş glifi — `EngagementRailV3`'ün bugünkü hâli. */
export const BOS_GLIF = "—";

/** Puanı hiç olmayan klibin `aria-label`'ı. */
export const OYSUZ_ARIA = "Henüz puan yok";

/**
 * Çözücünün girdisi. İki şekilden BİRİ yeter:
 *   · `{ count, sum }`   → `content/{id}.agg` (ground-truth)
 *   · `{ count, bayes }` → `clips/{id}` denorm (`v3_ratingAvg`)
 * İkisi de varsa `sum` kazanır (denorm bayat olabilir).
 */
export type KlipYildizKaynagi = {
  count?: unknown;
  sum?: unknown;
  bayes?: unknown;
};

export type KlipYildizModu = "yok" | "yolculuk" | "sayi";

/** Yüzeylerin basacağı KARAR. Hiçbir yüzey kendi formülünü taşımaz. */
export type KlipYildizGorunum = {
  mod: KlipYildizModu;
  /** Oy sayısı (kırpılmış, ≥ 0). Sayı gösterilmese de doğrudur. */
  count: number;
  /** `mod === "sayi"` ise 0..5 kırpılmış Bayes; aksi halde `null`. */
  deger: number | null;
  /** Geniş yüzey metni. `yok` → "", `yolculuk` → chip, `sayi` → "4.6". */
  metin: string;
  /** Dar yüzey metni. `yok`/`yolculuk` → "—", `sayi` → "4.6". */
  kisaMetin: string;
  /** `aria-label`. */
  erisilebilirlik: string;
};

function sayi(v: unknown): number {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function sayiVarMi(v: unknown): boolean {
  return v !== null && v !== undefined && v !== "" && Number.isFinite(Number(v));
}

/**
 * Bayes-yumuşatılmış ortalama — `(K·μ + sum) / (K + count)`.
 * `functions/src/agg_derive.ts bayesFrom` ile BİREBİR aynı gövde.
 */
export function bayesTuret(sum: number, count: number): number {
  return (PRIOR_STRENGTH * PRIOR_MEAN + sum) / (PRIOR_STRENGTH + count);
}

/**
 * `bayesTuret`in TERSİ — denorm `{count, bayes}`ten `sum`ı geri getirir.
 * İki girdi şeklinin aynı sayıya çıktığının cebirsel kanıtı budur; testte
 * gidiş-dönüş olarak koşturulur.
 */
export function toplamTuret(bayes: number, count: number): number {
  return bayes * (PRIOR_STRENGTH + count) - PRIOR_STRENGTH * PRIOR_MEAN;
}

function kirp(x: number): number {
  if (!Number.isFinite(x)) return 0;
  return Math.min(YILDIZ_TAVANI, Math.max(0, x));
}

/**
 * TEK KARAR NOKTASI. Bütün klip yüzeyleri buradan geçer.
 */
export function klipYildizGorunumu(
  k?: KlipYildizKaynagi | null,
): KlipYildizGorunum {
  const src: KlipYildizKaynagi = k && typeof k === "object" ? k : {};
  const count = Math.max(0, sayi(src.count));

  if (count <= 0) {
    return {
      mod: "yok",
      count: 0,
      deger: null,
      metin: "",
      kisaMetin: BOS_GLIF,
      erisilebilirlik: OYSUZ_ARIA,
    };
  }

  if (count < GUVEN_ESIGI) {
    return {
      mod: "yolculuk",
      count,
      deger: null,
      metin: YOLCULUK_METNI,
      kisaMetin: BOS_GLIF,
      erisilebilirlik: YOLCULUK_ARIA,
    };
  }

  // `sum` ground-truth'tur; denorm `bayes` yalnız `sum` yoksa okunur.
  const deger = sayiVarMi(src.sum)
    ? kirp(bayesTuret(Math.max(0, sayi(src.sum)), count))
    : kirp(sayi(src.bayes));

  const metin = deger.toFixed(1);
  return {
    mod: "sayi",
    count,
    deger,
    metin,
    kisaMetin: metin,
    erisilebilirlik: `Puan ${metin} / 5`,
  };
}

/**
 * `content/{id}.agg` (istemcide `aggNormalize`'dan geçmiş) → görünüm.
 * Bu yol `sum` taşır, yani ground-truth koldur.
 */
export function aggdanYildiz(
  agg?: { count?: unknown; sum?: unknown } | null,
): KlipYildizGorunum {
  return klipYildizGorunumu({ count: agg?.count, sum: agg?.sum });
}

/**
 * `clips/{id}` denorm alanları → görünüm.
 * Alan adları TEK YERDE burada bilinir (bkz. `src/utils/klipAlanlari.ts`
 * başlığı: "yazan taraf `v3_*` adını kullanıyor, okuyan taraf eski adı").
 * `v3_ratingAvg` `deriveAgg(...).bayes`tir — ham ortalama DEĞİL
 * (`functions/src/myclips_v3_rating_denorm.ts:42`).
 */
export function klipDokumanindanYildiz(
  clip?: { v3_ratingCount?: unknown; v3_ratingAvg?: unknown } | null,
): KlipYildizGorunum {
  return klipYildizGorunumu({
    count: clip?.v3_ratingCount,
    bayes: clip?.v3_ratingAvg,
  });
}
